import { parseSearchWith, stringifySearchWith } from '@tanstack/react-router'

// Clean share URLs (FMC tanstack-start-conventions → router-search-serialization.md).
//
// TanStack Router's default `stringifySearch` percent-encodes characters that are safe in
// query values but ugly in the location bar (`"` `,` `:` `[` `]` `{` `}` `/` …). Parsing
// still works, but links look like `tags=%5B%7B%22key%22%3A…`. We keep the default JSON
// parse and post-process the default stringify to decode the *safe* punctuation back.
//
// Intentionally kept encoded (URL breakers): `#` `&` `=` `<` `>` `` ` `` `%` `+`.

const parseSearch = parseSearchWith(JSON.parse)
const stringifySearchDefault = stringifySearchWith(JSON.stringify)

/** Decode safe query-value characters after the default stringify. */
const makeSearchPretty = (searchString: string) =>
  searchString
    .replaceAll('%22', '"')
    .replaceAll('%2C', ',')
    .replaceAll('%2F', '/') // map = z/lat/lng — `/` is part of the value, not a path
    .replaceAll('%27', "'")
    .replaceAll('%28', '(')
    .replaceAll('%29', ')')
    .replaceAll('%3A', ':')
    .replaceAll('%3B', ';')
    .replaceAll('%5B', '[')
    .replaceAll('%5D', ']')
    .replaceAll('%7B', '{')
    .replaceAll('%7D', '}')

export const routerSearch = {
  parse: parseSearch,
  stringify: (search: Record<string, unknown>) => makeSearchPretty(stringifySearchDefault(search)),
}
